import React from "react";

function GameExplanation() {

  return (
    <div className="explanation-text">
      <p>5 seconds to memorise</p>
      <p>5 seconds to click</p>
      <p>Missed circles are shown</p>
    </div>
  );
}

export default GameExplanation;
